export const TERMINOLOGY_SYSTEMS = [
  { value: 'http://snomed.info/sct', label: 'SNOMED CT' },
  { value: 'http://hl7.org/fhir/sid/icd-10', label: 'ICD-10' },
  { value: 'https://fhir.nhs.uk/Id/opcs-4', label: 'OPCS-4' },
  { value: 'https://dmd.nhs.uk', label: 'dm+d' }
];

export const DEFAULT_SNOMED_SYSTEM = 'http://snomed.info/sct';

export const DEFAULT_ANSWER = {
  concept: '',
  label: 'New Answer',
  conceptSystem: DEFAULT_SNOMED_SYSTEM,
  conceptCode: ''
};

// Create a new answer with unique ID (call this function instead of spreading DEFAULT_ANSWER)
export const createAnswer = (questionId = '', answerIndex = 0) => ({
  ...DEFAULT_ANSWER,
  id: `${questionId}_answer_${answerIndex}_${Date.now()}`
});

// Create a child answer with globally unique ID
export const createChildAnswer = (parentId = '') => ({
  ...DEFAULT_ANSWER,
  id: `${parentId}_child_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
});

export const DEFAULT_CHECKBOX_SELECT_ITEM = {
  checkboxTerminologySystem: DEFAULT_SNOMED_SYSTEM,
  checkboxLabel: '',
  checkboxTerminology: null,
  checkboxConceptCode: '',
  selectOptions: []
};

export const DEFAULT_SEPARATOR = { type: 'separator', label: '' };
export const DEFAULT_LINEBREAK = { type: 'linebreak', label: '' };

// Field types available from FormField for use as answer component types
// parametrable: true indicates the field type has configurable settings
export const ANSWER_FIELD_TYPES = [
  { value: 'text', label: 'Text Input' },
  { value: 'textarea', label: 'Text Area' },
  { value: 'number', label: 'Number' },
  { value: 'date', label: 'Date' },
  { value: 'checkbox', label: 'Checkbox' },
  { value: 'checkbox-with-text', label: 'Checkbox with Text' },
  { value: 'select', label: 'Dropdown Select' },
  { value: 'radio', label: 'Radio Group' },
  { value: 'scale', label: 'Scale (Slider)', parametrable: true },
  { value: 'file', label: 'File Upload' },
];

// List of parametrable field types (for quick lookup)
export const PARAMETRABLE_FIELD_TYPES = ANSWER_FIELD_TYPES
  .filter(t => t.parametrable)
  .map(t => t.value);

// Universal dependency source types
export const DEPENDENCY_SOURCE_TYPES = [
  { value: 'question', label: 'Question Value' },
  { value: 'answer', label: 'Specific Answer' },
  { value: 'section', label: 'Section Visibility' },
];

// Dependency comparison operators
export const DEPENDENCY_OPERATORS = [
  { value: '=', label: '=' },
  { value: '!=', label: '≠' },
  { value: 'exists', label: 'Exists' },
  { value: '!exists', label: 'Not Exists' },
];

// Default dependency condition
export const DEFAULT_CONDITION = {
  sourceType: 'question',
  question: '',
  operator: '=',
  answerCoding: ''
};

